export enum KeysEnum {
    enter = 13,
    esc = 27,
    space = 32,
    up = 38,
    down = 40,
    tab = 9,
    left = 37,
    right = 39,
    shift = 16
}

export enum CalculatorTypeKeyEnums {
    OverviewType = 'Overview',
    ServiceTypeSelectionType = 'ServiceTypeSelection',
    ProductSelectionType = 'ProductSelection',
    ContainerRangeType = 'ContainerRange',
    FrequencyRangeType = 'FrequencyRange',
    BusinessType = 'BusinessType',
    ConversionType = 'Conversion',
    StoryType = 'Story'
}